import { render, staticRenderFns } from "./ReservationEscalationFile.vue?vue&type=template&id=0a32d48d&scoped=true&"
import script from "./ReservationEscalationFile.vue?vue&type=script&lang=js&"
export * from "./ReservationEscalationFile.vue?vue&type=script&lang=js&"
import style0 from "./ReservationEscalationFile.vue?vue&type=style&index=0&id=0a32d48d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a32d48d",
  null
  
)

export default component.exports